import { axiosInstanceNew } from 'src/utils/axios';

export async function createDepositAuthorization(payload) {
  const body = {
    ...payload,

    tokenIn: payload.tokenIn || payload.tokenOne?.coingeckoId || payload.tokenOne?.ticker,
    tokenOut: payload.tokenOut || payload.tokenTwo?.coingeckoId || payload.tokenTwo?.ticker,

    from: payload.from || payload.address,
    sourceChainId: payload.sourceChainId || payload.destChain,
  };

  const res = await axiosInstanceNew.post('/swaps/deposit-authorization', body);

  return res.data;
}
